import { createAuthClient } from 'better-auth/react';

/**
 * Better Auth's browser client, used only for the email/password fallback and
 * for signing out. The LIFF path does not go through it — that exchange is a
 * single fetch in `lib/liff.ts`, and the resulting cookie is what every call
 * afterwards relies on.
 *
 * Same-origin by design (Vite proxy in dev, nginx in the container), which is
 * what keeps the session cookie first-party.
 */
export const authClient = createAuthClient({ basePath: '/auth' });
